import React from 'react'
import FeedDetailContent from '../components/FeedDetailContent'

const FeedDetailPage = props => <FeedDetailContent {...props} />

export default FeedDetailPage
